module.exports = __webpack_public_path__ + "img/HowWeAssess_tachometer.e7b019ad.svg";